<button 
  [ngClass]="getClassName()" 
  (click)="execute()">
  <i class="fa" *ngIf="getIconClassName()" [ngClass]="getIconClassName()"></i>
  {{ getTaskName() }}
</button>